import { getLocale } from "../runtime";

const da_youwillgetaorderconfirmation = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Du vil modtage en ordrebekræftelse på din e-mail inden for 30 minutter.`
};

const en_youwillgetaorderconfirmation = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `You will receive an order confirmation to your email within 30 minutes.`
};

const es_youwillgetaorderconfirmation = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Recibirás una confirmación del pedido en tu correo electrónico en los próximos 30 minutos.`
};

const fi_youwillgetaorderconfirmation = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Saat tilausvahvistuksen sähköpostiisi 30 minuutin kuluessa.`
};

const nb_youwillgetaorderconfirmation = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Du vil motta en ordrebekreftelse på e-post innen 30 minutter.`
};

const sv_youwillgetaorderconfirmation = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Du får en orderbekräftelse till din e-post inom 30min.`
};

const youwillgetaorderconfirmation = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_youwillgetaorderconfirmation(inputs)
	if (locale === "en") return en_youwillgetaorderconfirmation(inputs)
	if (locale === "es") return es_youwillgetaorderconfirmation(inputs)
	if (locale === "fi") return fi_youwillgetaorderconfirmation(inputs)
	if (locale === "nb") return nb_youwillgetaorderconfirmation(inputs)
	if (locale === "sv") return sv_youwillgetaorderconfirmation(inputs)
	return "youWillGetaOrderConfirmation";
};

export { youwillgetaorderconfirmation as "youWillGetaOrderConfirmation" };